import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal";
import { useRillContext } from "../../rill/RillReact/share/base";

const id = "modal-update-rep-maximum";

function SubmitForReviewModal(props) {
  const { locals } = useRillContext();
  const { t } = useTranslation("coaching-portal");

  const { params, query, editExercise, activeUser } = locals;

  return (
    <form
      action={`/actions/cycle/${params.cycleId}/`}
      method="POST"
      data-noreset
    >
      <input type="hidden" name="order" value={query.program} />
      <input type="hidden" name="source" value="review" />
      <Modal name={id} key={id} width="600px">
        <div className="head">
          <h2 className="alt">{t("submitForReview.title")}</h2>
        </div>

        <div className="body">
          <div className="columns">
            <div className="column" data-col="1/1">
              {t("submitForReview.sendCredentials")}{" "}
              <b>info@mystrengthbook.com</b>
            </div>
          </div>
          <p>{t("submitForReview.closeHint")}</p>
        </div>

        <div className="foot">
          <div className="columns">
            <div className="column" data-col="1/1">
              <p>
                <b>{t("submitForReview.adminOnly")}</b>
              </p>
            </div>
            <div className="column" data-col="1/2">
              <input
                className="text-input"
                type="password"
                name="password"
                placeholder={t("submitForReview.adminPasswordPlaceholder")}
              />
            </div>
            <div className="column" data-col="1/2">
              <button className="button-input" type="submit">
                {t("submitForReview.approve")}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </form>
  );
}

export { id };
export { SubmitForReviewModal as default };
